<script setup lang="ts">
definePage({
  meta: {
    allowAnonymous: true,
    layout: 'auth',
  },
})

const router = useRouter()

const { t } = useI18n()
</script>

<template>
  <AuthLayoutCard>
    <template #title>
      {{ t('pageNotFound.title') }}
    </template>

    <template #message>
      {{ t('pageNotFound.message') }}
    </template>

    <Button :label="t('pageNotFound.backButton')" @click="() => router.push('/')" rounded />
  </AuthLayoutCard>
</template>
